import { RichText } from '@almbrand/richtext';
import { ReactNode } from 'react';
import { useAppDispatch } from 'store/hooks';
import { setModal } from 'store/slices/modalSlice';

export const useModal = () => {
	const dispatch = useAppDispatch();

	const displayModal = (title: string, modalContent: ReactNode, text?: string) => {
		dispatch(
			setModal({
				displayModal: true,
				modalProps: {
					title: title,
					children: (
						<>
							{text && <RichText description={text} />}
							{modalContent}
						</>
					),
					handleClose: () => dispatch(setModal({ displayModal: false })),
					mode: 'default',
					mobileVariation: 'default',
				},
			})
		);
	};

	return { displayModal };
};
